<template>
  <AllstateSignUpComponent />
</template>

<script lang="ts">
import AllstateSignUpComponent from "@/components/Allstate/AllstateSignUp.vue";
import { defineComponent, onBeforeMount } from "vue";
import { useRouter } from "vue-router";
import { hasOnlyBestBuyS2 } from "@/common/bestBuy";

const componentName = "AllstateSignUpRoute";

export default defineComponent({
  name: componentName,
  components: { AllstateSignUpComponent },
  setup() {
    const router = useRouter();

    onBeforeMount(async () => {
      const bbyS2Only = await hasOnlyBestBuyS2();
      if (bbyS2Only) router.push("/home");
    });
  },
});
</script>
